<template>
    <div class="draws-container">
        <h5 class="text-center">{{ 'draw_tickets' | lang }}</h5>
        <b-list-group class="draw-tickets">
            <item class="bg-dark" v-for="ticket in tickets" :key="ticket.id" :ticket="ticket"></item>
        </b-list-group>
    </div>
</template>

<script>
import Item from './Item';
import { mapState } from 'vuex';

export default {
    props: ['gameId'],

    components: { Item },

    computed: {
        ...mapState(['channels']),

        nextDrawId() {
            const channelId = Config.games[this.gameId].channel_id;

            if (this.channels[channelId]) {
                return this.channels[channelId].draws.next._id;
            }
        },

      tickets() {
          return this.$store.getters.activeTicketsOfDraw(Config.games[this.gameId]);
      },
    },
}
</script>